import styled from "@emotion/styled";

export const Root = styled.div({});

export const OpenModalButton = styled.div({});
